<template>
    <div class="root-wrap">
        <div class="body-wrap fx-fill">
            <div class="fill-box fx-column">
                <div class="city_item-wrap">
                    <div class="city_title">定位城市</div>
                    <van-cell :title="locationName" clickable @click="doSelectLocation(location)" class="h06-py-city-item-click">
                        <div class="fx-end fx-column">
                            <div class="fx-row fx-center" @click.stop="doReposition">
                                <van-icon :name="require('@/assets/images/position_user.png')" size="20" :class="positioning ? 'positioning' : ''"></van-icon>
                                <span :style="`color:${$config.style.secondColor}`">{{positioning ? '定位中...' : '重新定位'}}</span>
                            </div>
                        </div>
                    </van-cell>
                </div>

                <div class="city_item-wrap">
                    <div class="city_title">当前选择城市</div>
                    <van-cell :title="selectedLocationName" clickable @click="doSelectLocation(selectedLocation)" class="h06-py-city-item-click"></van-cell>
                </div>

                <div class="city_item-wrap">
                    <div class="city_title">热门城市</div>
                    <van-cell v-for="(item, index) in hotCityList" :key="index" :title="item.name" clickable @click="doSelectLocation(item)" class="h06-py-city-item-click"></van-cell>
                </div>

                <!-- 所有城市 -->
                <div class="city_item-wrap fx-fill">
                    <van-index-bar :index-list="cityIndexList">
                        <template v-for="(item, index) in cityInfo">
                            <van-index-anchor :index="item.capital" :key="index">{{item.capital}}</van-index-anchor>
                            <van-cell v-for="(temp) in item.city" :key="temp.code" clickable @click="doSelectLocation(temp)" class="h06-py-city-item-click">{{temp.name}}</van-cell>
                        </template>
                    </van-index-bar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { buildCityList, movie_get_user_location } from '@/libs/map-utils.js';
export default {
    data() {
        return {
            cityIndexList: [],
            cityInfo: [],
            hotCityList: [],
            positioning: false,
        }
    },

    computed: {
        location() {
            return this.$store.state.app.location;
        },

        locationName() {
            return this.$store.state.app.location ? this.$store.state.app.location.name : '';
        },

        selectedLocation() {
            return this.$store.state.app.selectedLocation;
        },

        selectedLocationName() {
            return this.$store.state.app.selectedLocation ? this.$store.state.app.selectedLocation.name : this.$config.defaultLocation.name;
        }
    },

    methods: {
        doSelectLocation(item) {
          if(item){
            this.$store.commit('setSelectedLocation', item);
            this.$goPage(-1);
          }
        },

        get_city_list() {
            budo_log.info("#80 get_city_list")

            buildCityList().then((cityList) => {
                budo_log.info("#83 buildCityList", cityList)

                if (typeof cityList === 'string') cityList = JSON.parse(cityList)

                this.hotCityList = cityList.filter(item => item.ishot === true).map(self => { return { name: self.name, citycode: self.citycode } });

                let tempArr = cityList.map(item => item.pinyin.substr(0, 1));
                let searchLetter = Array.from(new Set(tempArr))

                this.cityIndexList = searchLetter;
                this.cityInfo = searchLetter.map(item => ({ capital: item, city: cityList.filter(self => self.pinyin[0] === item).map(self => { return { name: self.name, citycode: self.citycode } }), id: item }))
            });
        },

        doReposition() {
            this.positioning = true;
            movie_get_user_location(window.location.href).then(() => {
                this.positioning = false;
            }).catch(() => {
                this.positioning = false;
            });
        }
    },

    mounted() {
        // movie_get_user_location();
        this.get_city_list();
    }
}
</script>

<style lang="scss" scoped>
.body-wrap {
    position: relative;
	height: 100%;
	overflow-y: scroll;
	.city_item-wrap {
		.city_title {
			font-size: 15px;
			color: #818181;
			padding: 10px;
			padding-bottom: 0px;
			background-color: #fff;
		}
		.city_item {
			background-color: #fff;
			padding: 0 30px;
		}
	}
}

/deep/ .positioning {
	animation: turn 1.2s linear infinite;
}

@keyframes turn {
	0% {
		-webkit-transform: rotate(0deg);
	}
	25% {
		-webkit-transform: rotate(90deg);
	}
	50% {
		-webkit-transform: rotate(180deg);
	}
	75% {
		-webkit-transform: rotate(270deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
	}
}
</style>
